import React from "react";
import styled from "styled-components";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { CTA } from "../../../components/CTA";
import { z } from "zod";
import { BetaRegistrationMastheadBladeSchema, } from "../../../custom/betaExperience/schemas/BetaRegistrationMasthead";
import { useActionReducer } from "../../../context/ActionProvider";
export const GameBetaMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("gameBetaMasthead"),
});
const _GameBetaMasthead = ({ header, className, backdrop, buttons, platformIcons, gameIcon, ...bladeProps }) => {
    const { dispatchAction } = useActionReducer();
    return (React.createElement(BetaMasthead, { header: header, backdrop: backdrop, gameIcon: gameIcon, platformIcons: platformIcons, ...bladeProps },
        React.createElement("div", { className: "game-beta-ctas" }, buttons?.length &&
            buttons.map((button) => (React.createElement(CTA, { className: "cta", key: button?.title, onClick: () => dispatchAction(button?.action) }, button?.title))))));
};
export const GameBetaMasthead = styled(_GameBetaMasthead) ``;
//# sourceMappingURL=GameBetaMasthead.js.map